import { HttpError } from '@/services/fintalk/api/types/errors/HttpError'

export function isForbiddenResourceError(error: unknown): boolean {
  if (!(error instanceof HttpError) || error.response?.statusCode !== 403) {
    return false
  }

  return error.response.body?.error?.error_code === 'FORBIDDEN_RESOURCE'
}
